module.exports = __webpack_public_path__ + "media/assets/images/Logo_Esfera-19b76d17c794d1a37386a0bc1f1309cb.png";